import {tva} from "@gluestack-ui/nativewind-utils/tva";
import type React from "react";
import {memo} from "react";

import {Button} from "../button";

type Props = {
    isActive?: boolean;
    isDisabled?: boolean;
    children: React.ReactNode;
    onPress: () => void;
};

const buttonStyle = tva({
    base: "w-8 h-8 rounded-full flex-shrink-0"
});

const ButtonPage: React.FC<Props> = ({isActive, ...rest}) => {
    return (
        <Button
            no110MinWidth
            className={buttonStyle({})}
            variant={isActive ? "solid" : "outline"}
            {...rest}
        />
    );
};

export default memo(ButtonPage);
